(() => {
  const originalText = new WeakMap();
  const normalize = (value) => value.replace(/\s+/g, ' ').trim();
  const withoutSize = (title) => normalize(title
    .replace(/(\d+)\s*[×x]\s*\d+(?:[.,]\d+)?\s*(?:m\s*l|مل)\b/gi, '($1 Pieces)')
    .replace(/\b\d+(?:[.,]\d+)?\s*(?:m\s*l|millilit(?:er|re)s?|fl\.?\s*oz\.?|oz)\b|[\d٠-٩]+(?:[.,٫][\d٠-٩]+)?\s*مل/gi, '')
    .replace(/\(\s*\)|\[\s*\]/g, ''));
  const titleSelector = 'h1,h2,h3,h4,[role="heading"],.product-header a,[data-testid="sticky-product-title"],.sticky-add-to-cart__title';
  let scheduled = false;
  const updatePicker = (picker) => {
    const title = picker.dataset.productTitle;
    if (!title) return;
    const inputs = [...picker.querySelectorAll('input[type="radio"]:checked,select')];
    let values = inputs.map((input) => input.value);
    if (!values.length) {
      try {
        const variant = JSON.parse(picker.querySelector('script[type="application/json"]')?.textContent || 'null');
        values = variant?.options || [variant?.title || ''];
      } catch { return; }
    }
    const small = values.some((value) => value.toLowerCase().replace(/\s/g, '') === '30ml' || value.replace(/\s/g, '') === '٣٠مل' || value.replace(/\s/g, '') === '30مل');
    const root = picker.closest('quick-add-dialog,#quick-add-dialog') || picker.closest('featured-product-information,.product-information,product-card,.product-details');
    if (!root) return;
    const roots = [root];
    if (!picker.closest('quick-add-dialog,#quick-add-dialog,product-card')) {
      document.querySelectorAll('sticky-add-to-cart[data-product-id]').forEach((sticky) => {
        if (sticky.dataset.productId === picker.dataset.productId) roots.push(sticky);
      });
    }
    const full = normalize(title);
    const clean = withoutSize(title);
    for (const container of roots) {
      for (const heading of container.querySelectorAll(titleSelector)) {
        const current = normalize(heading.textContent);
        if (current !== full && current !== clean) continue;
        const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          const node = walker.currentNode;
          if (!originalText.has(node)) originalText.set(node, node.nodeValue);
          const original = originalText.get(node);
          const next = small ? withoutSize(original) : original;
          if (node.nodeValue !== next) node.nodeValue = next;
        }
      }
    }
  };
  const updateAll = () => {
    scheduled = false;
    document.querySelectorAll('variant-picker[data-product-title]').forEach(updatePicker);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateAll);
  };
  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.closest('variant-picker')) schedule();
  });
  new MutationObserver(schedule).observe(document.documentElement, {childList: true, subtree: true, characterData: true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once: true});
  else schedule();
})();
